import { gql } from '@apollo/client'

import { USER_AND_TOKENS_FRAGMENT } from '../fragments'

const LOGIN_WITH_EMAIL = gql`
  mutation loginWithEmail($email: EmailAddress!, $code: String!) {
    loginWithEmail(email: $email, code: $code) {
      ...UserAndTokensFragment
    }
  }

  ${USER_AND_TOKENS_FRAGMENT}
`

export default LOGIN_WITH_EMAIL
